import * as images from "@/components/images/Images";

const servicesProcessWorkSteps = [
  {
    title: "Elite human translator",
    description:
      "Our platform intelligently matches you with a professional translator we’ve vetted and tested for specialized experience in your industry and use case to complete your translation.",
    image: images.elit_icon,
    iconId: "icon-user-id_32",
  },
  {
    title: "Built-in quality assurance",
    description:
      "Automated validation of translation for spelling, grammar, and against our industry and use case guidelines.",
    image: images.built_in_icon,
    iconId: "icon-text-filed-focus_32",
  },
  {
    title: "Experienced editor",
    description:
      "A second human translator edits and proofreads for word choice, syntax, and against industry- and use-case-specific standards.",
    image: images.experince_icon,
    iconId: "icon-pen-new-square_32",
  },
  {
    title: "Dedicated project manager",
    description:
      "For enterprise clients, your project manager will review for quality and to validate adherence to your requirements.",
    image: images.dedicated_icon,
    iconId: "icon-clipboard-list_32",
  },
  {
    title: "Client approval",
    description:
      "We deliver your translation for your review and provide unlimited free revisions until you’re 100% satisfied.",
    image: images.approval_icon,
    iconId: "icon-file-check_32",
  },
];

export const ServicesProcessWorkMap = {
  standard: {
    title: "Rigorous quality control process",
    description:
      "Our proprietary multiple human workflow is fast, but highly accurate and is what ensures we deliver the highest accuracy consistently.",
    translationSteps: servicesProcessWorkSteps,
  },
  certified: {
    title: "Official document translation process",
    description:
      "Our user-friendly platform ensures high quality translation using a proprietary process with multiple layers of human review and built-in quality assurance to achieve the highest, consistent accuracy.",
    translationSteps: servicesProcessWorkSteps,
  },
  quality: {
    title: "Rigorous translation quality control",
    description:
      "Our user-friendly platform ensures high quality translation using a proprietary process with multiple layers of human review and built-in quality assurance to achieve the highest, consistent accuracy.",
    translationSteps: servicesProcessWorkSteps,
  }
};
